import { render, staticRenderFns } from "./TabsVideo.vue?vue&type=template&id=def9611c&scoped=true&"
import script from "./TabsVideo.vue?vue&type=script&lang=js&"
export * from "./TabsVideo.vue?vue&type=script&lang=js&"
import style0 from "./TabsVideo.vue?vue&type=style&index=0&id=def9611c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def9611c",
  null
  
)

export default component.exports